import { Text, Transforms } from 'slate';

const Type = 'disable-text-attributes';
const DisableTextAttributesPlugin = _options => ({
  type: Type,
  extendEditor(editor) {
    const {
      normalizeNode
    } = editor;
    editor.normalizeNode = entry => {
      const [node, path] = entry;
      if (Text.isText(node)) {
        const keys = Object.keys(node);
        if (keys.length !== 1) {
          // Unset attribtues
          const {
            text: _,
            ...attributes
          } = keys.reduce((acc, key) => {
            acc[key] = undefined;
            return acc;
          }, {});
          Transforms.setNodes(editor, attributes, {
            at: path
          });
          return;
        }
      }
      normalizeNode(entry);
    };
    return editor;
  }
});

export { DisableTextAttributesPlugin, Type };
